/**
 * UTC offset을 계산하여 timezone 정보를 반환합니다.
 *
 * @description
 * 현재 시스템의 timezone offset을 계산하여 "UTC +09:00" 형식으로 반환합니다.
 *
 * @returns "UTC +09:00" 형식의 timezone 문자열
 *
 * @example
 * ```typescript
 * const timezone = getTimezoneOffset();
 * // 한국 시간대: "UTC +09:00"
 * // 미국 동부: "UTC -05:00"
 * ```
 */
export const getTimezoneOffset = (): string => {
  const offset = -new Date().getTimezoneOffset();
  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;
  const sign = offset >= 0 ? '+' : '-';

  return `UTC ${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};
